module.exports = __webpack_public_path__ + "img/table-graph-md.12143cc7.svg";